'use client'
import React, { useRef, useState } from 'react'
import FavoriteImg from '../assets/images/favorites.svg'
import FavoriteRedImg from '../assets/images/favorites-filled.svg'
import DummyImage from '../assets/images/dummy-image.jpg'
import {
  categoryAlias,
  categoryTranslations,
  parameterIcons
} from '../helpers/utils'
import gsap from 'gsap'
import ArrowDown from '../assets/images/arrow_down.svg'
import { Link } from '@/src/navigation'
import { useTranslations } from 'next-intl'
import { useLocale } from 'use-intl'
import Image from 'next/image'
import useFavoritesStore from '../stores/favoritesStore'
import CardSlider from '@/src/app/[locale]/components/CardSlider'

// @ts-ignore
const Card = ({ data, favoriteIconRef = null, withSlider = false }: any) => {
  const t = useTranslations('')
  const currentLanguage = useLocale()

  const iconRef = useRef(null)
  const [showAllIcons, setShowAllIcons] = useState(false)

  const symbols: any = {
    rub: '₽',
    amd: '֏'
  }

  const preferredPrimaryKeys: any = {
    6: ['10', '12'],
    7: ['8', '10', '11'],
    8: ['33', '22', '34'],
    9: ['11', '15', '22']
  }
  const favorites = useFavoritesStore(state => state.favorites)
  const addFavorite = useFavoritesStore(state => state.addFavorite)
  const removeFavorite = useFavoritesStore(state => state.removeFavorite)
  const isFavorite = favorites.includes(data.id)

  const handleFavoriteToggle = () => {
    if (isFavorite) {
      removeFavorite(data.id)
    } else {
      addFavorite(data.id)
    }
  }

  const showAllParameters = () => {
    setShowAllIcons(!showAllIcons)
  }

  const animateFavoriteIcon = () => {
    if (!iconRef.current || !favoriteIconRef.current) return

    const icon: any = iconRef.current
    const target = favoriteIconRef.current
    const iconRect = icon.getBoundingClientRect()
    const targetRect = target.getBoundingClientRect()
    const dx = targetRect.left - iconRect.left
    const dy = targetRect.top - iconRect.top

    const clone = icon.cloneNode(true)
    clone.style.position = 'absolute'
    clone.style.left = `${iconRect.left}px`
    clone.style.top = `${iconRect.top}px`
    clone.style.width = `${iconRect.width}px`
    clone.style.height = `${iconRect.height}px`
    clone.style.zIndex = 1000
    clone.style.pointerEvents = 'none'
    document.body.appendChild(clone)

    gsap.to(clone, {
      duration: 4,
      x: dx,
      y: dy,
      scale: 0.5,
      opacity: 0.5,
      onComplete: () => {
        document.body.removeChild(clone)
      }
    })
  }
  const allParameters = Object.entries(data.parameters)
  const primaryIcons = allParameters.filter(([key]) =>
    preferredPrimaryKeys[data.category].includes(key)
  )
  const secondaryIcons = allParameters.filter(
    ([key]) => !preferredPrimaryKeys[data.category].includes(key)
  )

  return (
    <div className={`estate-cart-item home-card`}>
      <div className='estate-cart-item-image'>
        <Link
          lang={currentLanguage}
          prefetch={false}
          href={`/estate/view/${categoryAlias[data.category]}-${data.id}`}
          target='_blank'
          rel='noopener noreferrer'
        >
          {withSlider ? (
            <CardSlider images={data.images} estateData={data} />
          ) : (
            <Image
              src={data.image || data.images?.[0] || DummyImage}
              width='370'
              height='275'
              unoptimized={true}
              alt=''
              title=''
            />
          )}
        </Link>

        <div className='estate-cart-bottom-panel'>
          <div className='currencies'>
            <div className='card-price-container'>
              <p className='root_currency' id={`each-${data.id}`}>
                $ {data.price}
              </p>
              <ul
                className='other_currencies open-top'
                data-open={`each-${data.id}`}
              >
                {Object.keys(data.other_currencies).map((currency, index) => (
                  <li key={index} className='currency_item'>
                    {symbols[currency]} {data.other_currencies[currency]}
                  </li>
                ))}
              </ul>
            </div>
          </div>
          <small className='category'>
            {t(categoryTranslations[categoryAlias[data.category]])}
          </small>
        </div>

        <div className='control-favicon' onClick={handleFavoriteToggle}>
          <Image
            loading='lazy'
            src={isFavorite ? FavoriteRedImg : FavoriteImg}
            alt='favorite icon'
            className='favorite_icon'
            data-id={data.id}
            ref={iconRef}
            width='24'
            height='24'
            style={{ cursor: 'pointer' }}
          />
        </div>
        {/*<div className="control-card-logo">*/}
        {/*<img loading="lazy" src={CardLogo} alt="card logo" data-id={data.id} />*/}
        {/*</div>*/}
      </div>
      <div className='estate-cart-item-block'>
        <div className='location'>
          <p className='estate-cart-row-item-address'>{data.address}</p>
        </div>
      </div>
      <div className='estate-cart-item-footer'>
        <div className='estate-cart-icons'>
          {primaryIcons.map(([key, feature]: [string, any], index: number) => (
            <div key={index} className='estate-cart-icons-item'>
              <div className='estate-cart-single-icon'>
                <small className='text-small'>
                  {typeof feature === 'object' && feature !== null ? (
                    <>
                      <Image
                        src={parameterIcons[key]}
                        width='25'
                        height='24'
                        alt=''
                      />
                      <span
                        className='text-small'
                        style={{ marginLeft: '5px' }}
                      >
                        {feature.value} {key === '12' ? t('m2') : ''}
                      </span>
                    </>
                  ) : (
                    feature
                  )}
                </small>
              </div>
              <div className='estate-cart-single-icon-hover'>
                <small className='text-small'>
                  {typeof feature === 'object' && feature !== null
                    ? `${feature.name} ${feature.value}`
                    : feature}{' '}
                  {key === '12' ? t('m2') : ''}
                </small>
              </div>
            </div>
          ))}

          <div className='estate-cart-icons-toggle' onClick={showAllParameters}>
            <button className='toggle-button'>
              <p>{t('See all')}</p>
              <Image src={ArrowDown} width='16' height='16' alt='icon' />
            </button>
          </div>
        </div>
        {showAllIcons && (
          <div className='estate-cart-icons-row'>
            {secondaryIcons.map(([key, feature]: [string, any], index: number) => (
              <div key={index} className='estate-cart-icons-item'>
                <div className='estate-cart-single-icon'>
                  <small className='text-small'>
                    {typeof feature === 'object' && feature !== null ? (
                      <>
                        <Image
                          src={parameterIcons[key]}
                          width='25'
                          height='24'
                          alt=''
                        />
                        <span
                          className='text-small'
                          style={{ marginLeft: '5px' }}
                        >
                          {feature.value}
                        </span>
                      </>
                    ) : (
                      feature
                    )}
                  </small>
                </div>
                <div className='estate-cart-single-icon-hover'>
                  <small className='text-small'>
                    {typeof feature === 'object' && feature !== null
                      ? `${feature.name} ${feature.value}`
                      : feature}
                  </small>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  )
}

export default Card
